import { DEAL_CONTACT_ROLES } from '@/api/deals'
import { useAuthStore } from '@/features/auth/authStore'

/**
 * The roles a contact can play on a deal: the agency's editable list, falling back to
 * the built-in defaults when the (possibly stale, persisted) session has no list yet.
 */
export function useDealContactRoles(): string[] {
  const agency = useAuthStore((s) => s.agency)
  return agency?.dealContactRoles?.length ? agency.dealContactRoles : DEAL_CONTACT_ROLES
}
